import { render, staticRenderFns } from "./ArrowBtn.vue?vue&type=template&id=1bd87188"
import script from "./ArrowBtn.vue?vue&type=script&lang=js"
export * from "./ArrowBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports